








































import Vue from "vue";
import Modal from "@/components/root/modal/Modal.vue";
import { ModalConfig, UseModal } from "@/components/root/modal";
import VirtualTable from "@/components/table/VirtualTable.vue";
import TableRow from "./TableRow.vue";
import { table_config } from "./table.config";
import { onBeforeUnmount, onMounted, ref } from "@vue/composition-api";
import { EventBus } from "@/eventbus";
import { emptyFn } from "@/fp";
import * as menus from "./menus";
import { UseCollection } from "@/common/composition/use-collection";
import { AxisType } from "@/gql/types";
import * as api from "./api";
import EventsModalVue from "../events-modal/EventsModal.vue";
import { SharedState } from "@/common/state";
import { EventsModalProps } from "../events-modal/model";
import DropDownSimple from "@/components/dropdown/DropDownSimple.vue";
import { DataSourceType } from "@/views/customize/data-sources/data/model";
export default Vue.extend({
  components: {
    Modal,
    VirtualTable,
    DropDownSimple,
  },
  props: ["modalData"],
  setup(props) {
    // =========== info types =============
    const applications = ref(SharedState.data_sources.value);
    const selected_application = ref(applications.value[0]);

    const on_app_changed = async (source: any) => {
      if (selected_application.value.id !== source.id) {
        // @ts-ignore
        selected_application.value = source;
        await reload_data();
      }
    };
    // =================================

    const modal_config: ModalConfig = {
      title: "",
      desc: "",
      blank: true,
      withTopRightCloseBtn: true,
      backdropDismiss: true,
      width: "90rem",
      height: "55rem",
    };

    const entities_collection = UseCollection<
      any,
      { cursor: string; source: string }
    >(async ({ source }) => {
      return await api.get_info_type_count_for_source(source);
    });

    const load_more_entities = async () => {
      if (entities_collection.has_more.value) {
        await entities_collection.load_more_items();
      }
    };

    const on_show_events = async (p: {
      item: any;
      mode: "events" | "files";
      rowEl: HTMLElement;
    }) => {
      SharedState.ifIsPayingUser(
        async () => {
          if (SharedState.restrictions.is_restricted_info(p.item.l0.code)) {
            SharedState.restrictions.show_restrictions_modal(
              "info",
              p.item.l0.labelName
            );
            return;
          }
          const time_frame = SharedState.selectedTimeFrameOption.value;
          await UseModal().show(EventsModalVue, {
            title: `Events that involved <b>${p.item.l0.labelName}</b> information coming from <b>${selected_application.value.name}</b>`,
            files_title: `<b>${p.item.l0.labelName}</b> information files that have been shared from <b>${selected_application.value.name}</b>`,
            show_back: true,
            // @ts-ignore
            source: props.modalData.data_source,
            coordinates: [
              {
                x: {
                  type: AxisType.Application,
                  values: [selected_application.value.id],
                },
                y: {
                  type: AxisType.ContentLabel,
                  values: [p.item.id],
                },
                z: {
                  type: time_frame.type,
                  values: [time_frame.from],
                },
              },
            ],
          } as EventsModalProps);
        },
        { premium_modal_key: "applicationsharing-popup-2024" }
      );
    };

    const on_show_table_row_menu = (p: { item: any; event: MouseEvent }) => {
      menus.source_row_menu(p);
    };

    const subs = {
      show_events: emptyFn(),
      show_files: emptyFn(),
      show_menu: emptyFn(),
    };

    const reload_data = async () => {
      entities_collection.clear();
      await entities_collection.load_items({
        cursor: "",
        source: selected_application.value.id,
      });
    };

    onMounted(async () => {
      // @ts-ignore
      const only_sources: string[] = props.modalData.sources || [];
      if (only_sources && only_sources.length > 0) {
        applications.value = applications.value.filter((f) =>
          only_sources.includes(f.id)
        );
      }
      // @ts-ignore
      const initial_app_id: string = props.modalData.source;
      // @ts-ignore
      const data_source: DataSourceType = props.modalData.data_source;
      if (data_source == "google_workspace") {
        applications.value = applications.value.filter(
          (f) => f.id == "gdrive" || f.id == "gmail"
        );
      }
      // @ts-ignore
      selected_application.value = applications.value.find(
        (f: any) => f.id === initial_app_id
      );
      subs.show_events = EventBus.listen("show-events", on_show_events);
      subs.show_menu = EventBus.listen("showMenu", on_show_table_row_menu);
      await reload_data();
    });

    onBeforeUnmount(() => Object.values(subs).forEach((unsub) => unsub()));

    return {
      modal_config,
      table_config,
      applications,
      TableRow,
      is_loading: entities_collection.is_loading,
      has_no_results: entities_collection.has_no_results,
      items: entities_collection.items,
      load_more_entities,
      selected_application,
      on_app_changed,
    };
  },
});
